"use client";

import { motion, useReducedMotion } from "framer-motion";

const EASE_OUT = [0.22, 1, 0.36, 1];

export default function BlurFadeText({
  text,
  children,
  className = "",
  delay = 0,
  duration = 0.72,
  blur = 10,
  y = 18,
  once = true,
  amount = 0.45,
  as = "span",
}) {
  const shouldReduceMotion = useReducedMotion();
  const content = children ?? text;
  const MotionTag = as === "div" ? motion.div : motion.span;
  const WrapperTag = as === "div" ? "div" : "span";

  if (shouldReduceMotion) {
    return <WrapperTag className={className}>{content}</WrapperTag>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y, filter: `blur(${blur}px)` }}
      whileInView={{
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        transition: {
          delay,
          duration,
          ease: EASE_OUT,
        },
      }}
      viewport={{ once, amount }}
    >
      {content}
    </MotionTag>
  );
}
